import { StubErrorBoundary, StubPage } from '#app/components/stub-page.tsx'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Kiekonvalinta — Frisbeegolf' },
]

export default function Index() {
	return (
		<StubPage
			eyebrow="Frisbeegolf"
			title="Kiekonvalinta"
			intro="Miten valitset oikean kiekon omaan tasoon ja peliisi."
		/>
	)
}

export { StubErrorBoundary as ErrorBoundary }
